import { axios, handleApiErrors, getToken } from '../helpers'

export default ({ id, text, severity, files }) => {
  const token = getToken()
  const params = { token }
  const data = new FormData()

  if (files) {
    files.forEach((file) => {
      data.append('files', file)
    })
  }

  data.append(
    'body',
    text
      .split('\n')
      .map((piece) => `<p>${piece}</p>`)
      .join('')
  )

  if (severity) {
    data.append('severity', severity)
  }

  return axios
    .request({
      url: `interactions/${id}/events`,
      method: 'POST',
      params,
      data,
      timeout: 180000
    })
    .then(handleApiErrors)
}
